import { env } from '@/env';

/** sessionStorage key holding the OAuth2 CSRF state for the in-flight authorize redirect. */
export const CSRF_KEY = 'signcare.oauth.state';

// Begins the central-auth OAuth2 code flow: generates a CSRF state, stores it for
// the /auth/callback check, and navigates the browser to signcare-auth's
// /auth/authorize. The auth service either issues a code silently (SSO cookie
// present) or shows its hosted login page — which carries email+password,
// Google Sign-In, and the signup handoff (google-sign-in-plan).
// Shared by ProtectedRoute (the normal gate) and LegacyAuthRedirect (old
// /login-style deep links).
export function startAuthorizeRedirect(from?: string): void {
  const csrfState = crypto.randomUUID();
  sessionStorage.setItem(CSRF_KEY, csrfState);

  const callbackUrl = `${window.location.origin}/auth/callback`;

  const authorizeUrl =
    `${env.VITE_AUTH_URL}/auth/authorize` +
    `?redirect_uri=${encodeURIComponent(callbackUrl)}` +
    `&state=${encodeURIComponent(csrfState)}` +
    `&client_id=studio` +
    (from ? `&from=${encodeURIComponent(from)}` : '');

  window.location.assign(authorizeUrl);
}
